// extracted by mini-css-extract-plugin
export var bannerExperience = "BannerExperience-module--bannerExperience--63241";
export var bannerExperienceContent = "BannerExperience-module--bannerExperienceContent--beb2b";
export var bannerExperienceImage = "BannerExperience-module--bannerExperienceImage--39d71";
export var bannerExperienceLink = "BannerExperience-module--bannerExperienceLink--d2c74";